export default "__VITE_ASSET__DhrdwTqO__"